import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { Row, Col } from 'react-flexbox-grid'
import styled from 'styled-components'

import { Modal } from 'components/Modal'
import { WarningModal } from 'components/Modal'
import { Form, Select, Text } from 'components/forms'
import DataTable from 'components/DataTableTest'
import { useMutation, updateQuery } from 'components/graphql'
import Divider from 'components/Divider'
import Button from 'components/Button'
import { listProducts } from '../../../product/gql/query'
import { defaultOrderModal } from '../../tableColumns'
import createStandardOrderValuesMutation from '../../gql/mutation/createStandardOrder'
import updateStandardOrderValuesMutation from '../../gql/mutation/updateStandardOrder'
import { getStandardOrderValues } from '../../gql'

const Inline = styled.div`
	display: flex;
	justify-content: flex-end;
`

const setInputData = (data, t) => {
	let items = []
	const fields = [
		{ type: 'weekAmount', caption: 'amount' },
		{ type: 'weekAmountNew', caption: 'new_amount' },
		{ type: 'weekMinAmount', caption: 'minimum' },
		{ type: 'weekMaxAmount', caption: 'maximum' },
		{ type: 'weekAllottedAmount', caption: 'alloted' }
	]
	fields.forEach(el => {
		items.push({
			amountType: el.type,
			amountCaption: t('credit_client_section.strings.' + el.caption),
			monday: data ? nullToStr(data[el.type][0]) : '',
			tuesday: data ? nullToStr(data[el.type][1]) : '',
			wednesday: data ? nullToStr(data[el.type][2]) : '',
			thursday: data ? nullToStr(data[el.type][3]) : '',
			friday: data ? nullToStr(data[el.type][4]) : '',
			saturday: data ? nullToStr(data[el.type][5]) : '',
			sunday: data ? nullToStr(data[el.type][6]) : ''
		})
	})
	return items
}

const nullToStr = (value) => {
	if (value === null) {
		return ''
	}
	return value
}

const DefaultOrderModal = props => {
	const [t] = useTranslation()
	const [skipPageReset, setSkipPageReset] = React.useState(false)
	const [alreadyExistProduct, setAlreadyExistProduct] = React.useState(false)
	const [data, setData] = React.useState(() => setInputData(props.data, t))

	const [createStandardOrderValues] = useMutation(createStandardOrderValuesMutation)
	const [updateStandardOrderValues] = useMutation(updateStandardOrderValuesMutation)

	const submitHandler = (formData) => {
		if (props?.data?.id) {
			updateStandardOrderValues({
				variables: {
					id: props.data.id,
					fields: {
						productId: formData.productId,
						// information: formData.information,
						weekAmount: getWeekValuesByType('weekAmount'),
						weekAmountNew: getWeekValuesByType('weekAmountNew'),
						weekMinAmount: getWeekValuesByType('weekMinAmount'),
						weekMaxAmount: getWeekValuesByType('weekMaxAmount'),
						weekAllottedAmount: getWeekValuesByType('weekAllottedAmount')
					}
				},
				update: updateQuery({
					query: getStandardOrderValues,
					variables: { filter: { creditClientId: props.creditClientId } } }, (draft, { mutationResult, readQuery, queryField }) => {
					const newItems = readQuery.items.map((item = {}) => Number(item.id) === Number(mutationResult.id) ? { ...item, mutationResult } : item)
					draft[queryField].items = newItems
				})
			})
			props.unmount()
		} else if (!props?.data?.id && !props.existProducts.some(product => Number(product) === Number(formData.productId))) {
			createStandardOrderValues({
				variables: {
					required: {
						creditClientId: props.creditClientId,
						productId: formData.productId
					},
					fields: {
						// information: formData.information,
						weekAmount: getWeekValuesByType('weekAmount'),
						weekAmountNew: getWeekValuesByType('weekAmountNew'),
						weekMinAmount: getWeekValuesByType('weekMinAmount'),
						weekMaxAmount: getWeekValuesByType('weekMaxAmount'),
						weekAllottedAmount: getWeekValuesByType('weekAllottedAmount')
					}
				},
				update: updateQuery({
					query: getStandardOrderValues,
					variables: { filter: { creditClientId: props.creditClientId } } }, (draft, { mutationResult, readQuery, queryField }) => {
					const oldItems = [...readQuery.items]
					const newItems = oldItems.concat([mutationResult])
					draft[queryField].items = newItems
				})
			})
			props.unmount()
		} else {
			setAlreadyExistProduct(true)
		}
	}

	const getWeekValuesByType = (type) => {
		const typeData = { ...data.find(el => el.amountType === type) }
		delete typeData.amountType
		delete typeData.amountCaption
		const finalData = []
		Object.values(typeData).forEach(el => {
			if (el === '') {
				finalData.push(null)
			} else {
				finalData.push(parseInt(el, 10))
			}
		})
		return finalData
	}

	const updateMyData = (rowIndex, columnId, value) => {
		// We also turn on the flag to not reset the page
		setSkipPageReset(true)
		setData(old =>
		  	old.map((row, index) => {
				if (index === rowIndex) {
					return {
						...old[rowIndex],
						[columnId]: value
					}
				}
				return row
			})
		)
	}

	// After data chagnes, we turn the flag back off
  	// so that if data actually changes when we're not
	// editing it, the page is reset
	React.useEffect(() => {
		setSkipPageReset(false)
	}, [data])

	return(
		<>
			<Modal {...props} width={1253} label={t('credit_client_section.strings.create_day_order')}>
				<Form
					initialValues={{ productId: props?.data?.product?.id, information: '' }}
					onSubmit={submitHandler}
					render={() => (
						<Fragment>
							<Row>
								<Col xs={3}>
									<Row>
										<Col xs={12}>
											<Select
												label={t('common.fields.name')}
												field='productId'
												style={{ width: '100%' }}
												valueField='id'
												labelField='name'
												withVirtualBody={true}
												isSearchable={true}
												remoteOptions={{
													query: listProducts
												}}
											/>
										</Col>
									</Row>
									<Divider height={20} />
									<Row>
										<Col xs={12}>
											<Text
												field='information'
												style={{ width: '100%' }}
												label={t('credit_client_section.strings.information')}
											/>
										</Col>
									</Row>
								</Col>
								<Col xs={9}>
									<Divider height={40}/>
									<DataTable
										columns={defaultOrderModal(t)}
										data={data}
										withSearch={false}
										updateMyData={updateMyData}
										skipPageReset={skipPageReset}
									/>
								</Col>
							</Row>
							<Divider height={200} />
							<Row>
								<Col xs>
									<Inline>
										<Button
											type='button'
											onClick={() => props.unmount()}
											status='cancelation'
											text={t('common.buttons.abort')}/>
										<Button
											type='submit'
											status='primary'
											text={t('common.buttons.calculate')}/>
									</Inline>
								</Col>
							</Row>
						</Fragment>
					)}/>
			</Modal>
			{alreadyExistProduct &&
			<WarningModal
				label={t('credit_client_section.strings.warning')}
				text={t('credit_client_section.error.article_already_exist')}
				onClose={() => setAlreadyExistProduct(false)}
			/>}
		</>
	)
}

export default DefaultOrderModal
